import { CurrencyCode } from 'corso-types';
import { redirectDocument } from 'react-router-dom';
import api from '~/utils/api';
import {
  getParentLocation,
  isAppEmbedded,
  navigateParent,
} from '~/utils/appEmbed';
import { computeShopNowIncentive } from '~/utils/claimLineItem';
import { makeCrewClaimAction, makeCrewClaimLoader } from '~/utils/routing';

export const { loader, useLoaderData } = makeCrewClaimLoader(({ context }) => {
  const { order, crewClaim } = context;

  // TODO: SHOP NOW - verify we should calculate again here vs. pulling from context
  const incentive = computeShopNowIncentive(
    crewClaim.claimLineItems,
    order.offerShopNow?.shopNowIncentive,
  );

  return {
    credit: incentive.lineItemTotal,
    incentive: incentive.amount,
  };
});

const handleRedirect = (url: string) => {
  if (isAppEmbedded()) {
    navigateParent(url);

    return {
      ok: true,
      message: 'Redirecting parent',
    };
  }

  return redirectDocument(url);
};

export const { action, useActionResult } = makeCrewClaimAction(
  async (
    { context: { crewClaim, order, settings }, request, params },
    appStore,
  ) => {
    if (!order.offerShopNow) {
      throw new Error('Shop Now is not available for this order');
    }

    // remove any previous shop now results to start a new session
    appStore.dispatch(appStore.actions.crewClaim.clearShopNowResults());

    const returnUrl =
      isAppEmbedded() ?
        await getParentLocation()
      : new URL(`${params.store}`, new URL(request.url)).href;

    const incentive = computeShopNowIncentive(
      crewClaim.claimLineItems,
      order.offerShopNow.shopNowIncentive,
    );

    appStore.dispatch(
      appStore.actions.crewClaim.setShopNowIncentiveAmountApplied(
        incentive.amount,
      ),
    );

    return api
      .createShopNowSession({
        params: { storefrontId: settings.storefrontId },
        body: {
          orderIdFromPlatform: order.idFromPlatform,
          shopNowEvent: order.offerShopNow,
          customerAppHostConfig:
            isAppEmbedded() ?
              {
                type: 'embedded',
                parentHostUrl: returnUrl,
                orderIdFromPlatform: order.idFromPlatform,
              }
            : {
                type: 'standalone',
                slug: settings.storeSlug,
                orderIdFromPlatform: order.idFromPlatform,
              },
          returnCreditTotal: {
            amount: incentive.lineItemTotal + incentive.amount,
            currencyCode: order.currencyCode as CurrencyCode, // TODO fix currency code without casting
          },
        },
      })
      .then(({ startShoppingIdUrl }) => handleRedirect(startShoppingIdUrl));
  },
);
